import { iDocSpeakerDataMap } from './docSpeaker.type';

import { docSpeakerEffects, docSpeakerReducers } from './docSpeaker.operator';

// DocSpeaker 初始状态
export const docSpeakerInitData: iDocSpeakerDataMap = {};

// DocSpeaker Model
export const docSpeakModel = {
  state: docSpeakerInitData,
  reducers: docSpeakerReducers,
  effects: docSpeakerEffects,
};
